<template lang="pug">
.loan-history
  .header-margin-bottom
  .member-center-header
    .arrow_icon(@click="$router.go(-1)")
      img(src="@/assets/images/arrow_left.svg", alt="alt")
    h1 租借歷史
  .info-list
    .history_title 租借訂單記錄
    .info-nodata(v-if="orders.lenght <= 0") 目前無資料
    .info-item(
      v-for="(order,index) in orders"
      @click="goOrderDetail(order)"
    )
      .info-title 
        span {{ order.number }}
        span {{ ' - ' + $root.common.getNowTime('date', order.start_time) }}
      .icon-box
        img(src="@/assets/images/arrow_right.svg")

</template>

<script>
export default {
  name: "order-history",
  components: {},
  data () {
    return {
      orders: []
    };
  },
  mounted () { },
  created () {
    this.getOrderList()
  },
  methods: {
    getOrderList () {
      let vm = this
      this.$root.apis.getOrderList(this.$root.member.user_lineId, async function (_response) {
        let orders = _response.body.data
        let OrderDataList = []
        await orders.forEach(function (_order) {
          _order.data = JSON.parse(_order.data)
          OrderDataList.push(_order)
        })

        vm.orders = orders
      })
    },
    goOrderDetail (_order) {
      console.log('--> 前往訂單:', _order)
      this.$root.$router.push({ name: 'HistoricalOrder', params: { order: _order } })
    }
  },
};
</script>
<style lang="sass" scoped>
body
  position: relative
.loan-history
  background-color: #000
  padding: 0 15px
  height: 100%
  overflow: auto
  .arrow_icon
    position: absolute
    top: 5vmin
    left: 6.1vmin
  h1
    font-size: 19px
    font-weight: 700
    text-align: center
    color: #fff
    padding-top: 6vmin
  .info-list
    margin-top: 12.5vmin
    .history_title
      color: #22F48F
      font-size: 4.5vmin
      font-weight: 700
      margin-bottom: 5vmin
    
    .info-nodata
      color: #FFF
      padding-top: 15vmin
      text-align: center
    .info-item     
      display: flex
      justify-content: space-between
      align-items: center
      padding: 6.5vmin 0
      .info-title
        color: #898A8D
        font-size: 5vmin
        font-weight: 400
        padding-left: 2.5vmin
      .icon-box
        width: 6vmin
        height: 6vmin
      .arrow-box
        width: 3vmin
        height: 6.5vmin
        img
          width: 100%
.header-margin-bottom
  margin-bottom: 75px
.member-center-header
  position: fixed
  left: 0px
  top: 0px
  width: 100%
  background: #000
  z-index: 10
  height: 75px
</style>
